import {
  Users,
  HeartHandshake,
  RefreshCw,
  ShieldCheck,
  Car,
  Building2,
} from "lucide-react";

const groups = [
  {
    icon: Users,
    heading: "NDIS Participants",
    body: "Everwell provides community nursing services to self-managed and plan-managed NDIS participants across Canberra and nearby NSW. We work collaboratively with participants, families, support coordinators, plan managers, supported independent living providers and allied health professionals.",
  },
  {
    icon: HeartHandshake,
    heading: "Support at Home Providers",
    body: "We provide subcontracted community nursing services to Support at Home providers requiring reliable local clinical capacity, continuity of care and responsive nursing support for their clients.",
  },
  {
    icon: RefreshCw,
    heading: "Transition Care Program Providers",
    body: "Everwell can support Transition Care Program providers with short-term community nursing following hospital discharge, helping clients recover safely, maintain independence and reduce the risk of avoidable hospital readmission.",
  },
  {
    icon: ShieldCheck,
    heading: "DVA Providers",
    body: "We partner with approved DVA and community care providers through subcontracting and brokerage arrangements to deliver eligible nursing services to veterans and war widows in their homes.",
  },
  {
    icon: Car,
    heading: "CTP and Motor Accident Clients",
    body: "We provide community nursing services for people recovering from motor vehicle injuries through approved insurers, rehabilitation providers, case managers and other authorised referral pathways. This includes CTP and ACT Motor Accident Injuries Scheme referrals, subject to referral, funding approval or a letter of authority where required.",
  },
  {
    icon: Building2,
    heading: "Healthcare & Community Care Organisations",
    body: "We support aged care providers, disability organisations, rehabilitation services, hospitals, discharge teams and community care providers requiring additional nursing capacity or specialised community-based clinical support.",
  },
];

export const WhoWeHelp = () => {
  return (
    <section
      id="who-we-help"
      data-testid="who-section"
      className="relative py-20 sm:py-28 bg-[var(--ew-bg-3)]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="eyebrow">Who We Help</p>
          <h2 className="font-heading font-medium mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] text-[var(--ew-text)]">
            Direct nursing for individuals. Flexible support for providers.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[var(--ew-text-2)] leading-relaxed">
            Everwell works with participants directly and partners with
            organisations that need dependable community nursing capacity.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {groups.map((g, i) => (
            <article
              key={g.heading}
              data-testid={`who-group-${i}`}
              className="ew-card p-7 sm:p-8"
            >
              <div className="flex items-center gap-4">
                <div className="icon-badge">
                  <g.icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <h3 className="font-heading text-xl sm:text-[1.35rem] font-semibold text-[var(--ew-text)] leading-snug">
                  {g.heading}
                </h3>
              </div>
              <p className="mt-4 text-[var(--ew-text-2)] leading-relaxed text-sm sm:text-base">
                {g.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;
